/**
 * Colour Selector Drawer
 * Handles open/close for div-based drawer
 */

document.addEventListener('DOMContentLoaded', function() {
  // Handle trigger buttons
  document.addEventListener('click', function(e) {
    const trigger = e.target.closest('[data-drawer-trigger]');
    if (trigger) {
      e.preventDefault();
      const drawerId = trigger.getAttribute('data-drawer-trigger');
      const drawer = document.querySelector(drawerId);
      if (drawer) {
        if (!drawer.dataset.portalized) {
          document.body.appendChild(drawer);
          drawer.dataset.portalized = 'true';
        }
        openDrawer(drawer);
      }
    }
    
    // Handle close buttons
    const closeButton = e.target.closest('[data-drawer-close]');
    if (closeButton) {
      e.preventDefault();
      const drawer = closeButton.closest('[data-drawer]');
      if (drawer) {
        closeDrawer(drawer);
      }
    }
    
    // Handle backdrop clicks
    const backdrop = e.target.closest('[data-drawer-backdrop]');
    if (backdrop) {
      const drawer = backdrop.closest('[data-drawer]');
      if (drawer) {
        closeDrawer(drawer);
      }
    }
  });
  
  // Handle escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      const openDrawer = document.querySelector('[data-drawer][aria-hidden="false"]');
      if (openDrawer) {
        closeDrawer(openDrawer);
      }
    }
  });
  
  function openDrawer(drawer) {
    const trigger = document.querySelector(`[data-drawer-trigger="#${drawer.id}"]`);
    if (trigger) {
      trigger.setAttribute('aria-expanded', 'true');
    }
    
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    
    // Force reflow to trigger transition
    drawer.offsetHeight;
    
    // Add opening class after a frame to trigger animation
    requestAnimationFrame(function() {
      drawer.classList.add('tw-drawer--opening');
      drawer.classList.remove('tw-drawer--closing');
    });
  }
  
  function closeDrawer(drawer) {
    const trigger = document.querySelector(`[data-drawer-trigger="#${drawer.id}"]`);
    if (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
    }
    
    drawer.classList.remove('tw-drawer--opening');
    drawer.classList.add('tw-drawer--closing');
    
    setTimeout(function() {
      drawer.setAttribute('aria-hidden', 'true');
      drawer.classList.remove('tw-drawer--closing');
      document.body.style.overflow = '';
    }, 300);
  }
});
